import { getUrl } from '@/config/url'

export const SYSTEM_ID = '3'
export const API_SUCCESS_CODE = 0
export const API_KEY = 'sdf59s4d$JKf-/sdf23fwf'
export const API_CHANNEL = 99
export const API_TIMEOUT_TIP = '請求超時，請重試'
export const API_NETERROR_TIP = '網絡出現問題，請檢查網絡後重試'
export const API_LOADING = true
export const SUCCESS_CODE = 200
export const API_GLOBAL_LOADING_ID = 'global-loading'
export const API_NAME = ['base', 'login']
export function generateApiConfig (name) {
  return {
    timeout: 20000,
    baseURL: getUrl(name),
    headers: {}
  }
}
// export const API_CONFIG = {
//   timeout: 20000,
//   baseURL: baseURL, // 用戶中心
//   headers: {}
// }

export const GET_TOEKN = function () {
  return localStorage.token
}

export const API_USER_CODE = function (res) {
  return res.code || 0
}

export const API_LEVEL1_CODE = function (res) {
  return res.resultCode || 400
}

export const API_LEVEL1_CODE_MSG = function (res) {
  return res.subMsg && res.subMsg.bMsg
}

export const API_LEVEL2_CODE = function (res) {
  return (res.subMsg && res.subMsg.bCode) || (res.businessMsg && res.businessMsg.businessCode)
}

export const API_LEVEL2_CODE_MSG = function (res) {
  return (res.subMsg && res.subMsg.bMsg) || (res.businessMsg && res.businessMsg.businessNote)
}

export const API_RESULT = function (res) {
  return res.detailMsg || res.result || res
}
export const SESSION_ID = getSessionId()

function getSessionId () {
  const sessionId = localStorage.sessionId || Math.floor(Math.random() * 1000000)
  localStorage.sessionId = sessionId
  return sessionId
}
